import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCpu, FiGrid, FiCalendar, FiBookOpen, FiBox, FiSettings, FiPlayCircle } = FiIcons;

const navItems = [
  { id: 'dashboard', label: 'Command', icon: FiGrid },
  { id: 'board', label: 'Meal Board', icon: FiCalendar },
  { id: 'recipes', label: 'Recipes', icon: FiBookOpen },
  { id: 'pantry', label: 'Pantry', icon: FiBox },
  { id: 'demo', label: 'Demo', icon: FiPlayCircle },
  { id: 'settings', label: 'Settings', icon: FiSettings },
];

export const Sidebar = ({ activeTab, setActiveTab }) => {
  return (
    <div className="hidden md:flex flex-col w-64 bg-steel-900 h-screen fixed top-0 left-0 text-cream-100 z-50 border-r border-steel-800 shadow-2xl">
      <div className="p-8 flex items-center gap-4 border-b border-steel-800 font-mono">
        <div className="w-10 h-10 bg-tomato-500 rounded-sm flex items-center justify-center shadow-lg shadow-tomato-500/30">
          <SafeIcon icon={FiCpu} className="text-white text-2xl" />
        </div>
        <div className="flex flex-col">
          <span className="text-xl font-bold tracking-[0.2em] text-white">COOK</span>
          <span className="text-[10px] font-bold tracking-[0.4em] text-tomato-400 -mt-1 uppercase">Circuit</span>
        </div>
      </div>
      
      <div className="flex-1 py-8 flex flex-col gap-2 px-4">
        {navItems.map((item) => {
          const isActive = activeTab === item.id;
          return (
            <button
              key={item.id}
              onClick={() => setActiveTab(item.id)}
              className={`flex items-center gap-4 px-5 py-4 rounded-sm transition-all duration-300 relative group overflow-hidden ${
                isActive ? 'text-white' : 'text-steel-400 hover:text-white hover:bg-steel-800/50'
              }`}
            >
              {isActive && (
                <motion.div
                  layoutId="activeNavDesktop"
                  className="absolute inset-0 bg-steel-800 border-l-[4px] border-tomato-500"
                  initial={false}
                  transition={{ type: "spring", stiffness: 400, damping: 40 }}
                />
              )}
              <span className="relative z-10 flex items-center gap-4">
                <SafeIcon icon={item.icon} className={`text-lg transition-colors ${isActive ? 'text-tomato-400' : 'text-steel-600 group-hover:text-tomato-300'}`} />
                <span className="text-[11px] font-bold uppercase tracking-[0.2em]">{item.label}</span>
              </span>
            </button>
          )
        })}
      </div>

      <div className="p-8 border-t border-steel-800 text-[9px] text-steel-500 font-mono space-y-2">
        <div className="flex justify-between uppercase tracking-widest">
          <span>System Status</span>
          <span className="text-green-500 font-bold">Nominal</span>
        </div>
        <div className="flex justify-between uppercase tracking-widest">
          <span>Firmware</span>
          <span>v2.4.1.a</span>
        </div>
        <div className="pt-4 opacity-30 text-[8px] text-center uppercase tracking-tighter">
          LingLink x DigLab
        </div>
      </div>
    </div>
  );
};

export const BottomNav = ({ activeTab, setActiveTab }) => {
  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 bg-steel-900 text-cream-100 border-t border-steel-800 z-50 pb-safe shadow-[0_-10px_30px_rgba(0,0,0,0.3)]">
      <div className="flex justify-around items-center h-20">
        {navItems.map((item) => {
          const isActive = activeTab === item.id;
          return (
            <button
              key={item.id}
              onClick={() => setActiveTab(item.id)}
              className="flex flex-col items-center justify-center w-full h-full relative group"
            >
              {isActive && (
                <motion.div
                  layoutId="activeNavMobile"
                  className="absolute top-0 w-10 h-1.5 bg-tomato-500 rounded-b-sm shadow-[0_0_10px_rgba(230,57,70,0.5)]"
                  initial={false}
                />
              )}
              <SafeIcon 
                icon={item.icon} 
                className={`text-2xl mb-1.5 transition-colors ${isActive ? 'text-tomato-400' : 'text-steel-600'}`} 
              />
              <span className={`text-[8px] uppercase font-black tracking-widest ${isActive ? 'text-white' : 'text-steel-600'}`}>
                {item.label}
              </span>
            </button>
          )
        })}
      </div>
    </div>
  );
};